(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapPaddingThicknessData = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "defaultPadding": "flat",
  "defaultThickness": "2.5-1.8",
  "paddingRules": {
    "flat": {
      "recommendedThickness": "2.5-1.8",
      "unsupportedThicknesses": []
    },
    "square": {
      "recommendedThickness": "3.5-2",
      "unsupportedThicknesses": [
        "2-1.6",
        "2.5-1.8"
      ]
    },
    "domed": {
      "recommendedThickness": "4.5-2",
      "unsupportedThicknesses": []
    },
    "full": {
      "recommendedThickness": "3.5-2",
      "unsupportedThicknesses": []
    }
  },
  "padding": [
    {
      "id": "flat",
      "label": "Flat (Default)",
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "square",
      "label": "Square",
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "domed",
      "label": "Domed",
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "full",
      "label": "Full",
      "disabled": false,
      "priceModifier": null
    }
  ],
  "standardThickness": [
    {
      "id": "2-1.6",
      "label": "2.0 → 1.6 mm",
      "lugMm": 2,
      "tipMm": 1.6,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "2.5-1.8",
      "label": "2.5 → 1.8 mm",
      "lugMm": 2.5,
      "tipMm": 1.8,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "3-2",
      "label": "3.0 → 2.0 mm",
      "lugMm": 3,
      "tipMm": 2,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "3.5-2",
      "label": "3.5 → 2.0 mm",
      "lugMm": 3.5,
      "tipMm": 2,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "4-2",
      "label": "4.0 → 2.0 mm",
      "lugMm": 4,
      "tipMm": 2,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "4.5-2",
      "label": "4.5 → 2.0 mm",
      "lugMm": 4.5,
      "tipMm": 2,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "4.5-2.3",
      "label": "4.5 → 2.3 mm",
      "lugMm": 4.5,
      "tipMm": 2.3,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "5-2.5",
      "label": "5.0 → 2.5 mm",
      "lugMm": 5,
      "tipMm": 2.5,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "5.5-2.5",
      "label": "5.5 → 2.5 mm",
      "lugMm": 5.5,
      "tipMm": 2.5,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "custom",
      "label": "Custom thickness…",
      "lugMm": null,
      "tipMm": null,
      "disabled": false,
      "priceModifier": null
    }
  ],
  "foldingThickness": [
    {
      "id": "2-1",
      "label": "2.0-1.0 mm",
      "lugMm": 2,
      "tipMm": 1,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "2.5-1",
      "label": "2.5-1.0 mm",
      "lugMm": 2.5,
      "tipMm": 1,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "3-1",
      "label": "3.0-1.0 mm",
      "lugMm": 3,
      "tipMm": 1,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "3.5-1",
      "label": "3.5-1.0 mm",
      "lugMm": 3.5,
      "tipMm": 1,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "4-1",
      "label": "4.0-1.0 mm",
      "lugMm": 4,
      "tipMm": 1,
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "4.5-1",
      "label": "4.5-1.0 mm",
      "lugMm": 4.5,
      "tipMm": 1,
      "disabled": false,
      "priceModifier": null
    }
  ],
  "routing": {
    "standardActiveExcept": [
      "nato",
      "single-folding",
      "double-folding"
    ],
    "foldingActiveFor": [
      "single-folding",
      "double-folding"
    ],
    "noThicknessFieldFor": [
      "nato"
    ]
  },
  "bounds": {
    "finite": true,
    "exclusiveMinimum": 0,
    "maximum": null,
    "maximumStatus": "not-specified-by-source",
    "safetyMaximumByField": {
      "customLugWidthMm": 50,
      "customBuckleWidthMm": 50,
      "customLengthLongEnd": 300,
      "customLengthShortEnd": 300,
      "wristLengthMm": 400,
      "watchLugToLugMm": 100,
      "styleMeasurement": 100,
      "customThicknessMm": 15
    }
  }
});

  function getRoute(style) {
    if (DATA.routing.noThicknessFieldFor.includes(style)) return 'none';
    if (DATA.routing.foldingActiveFor.includes(style)) return 'folding';
    return 'standard';
  }

  function getPaddingOption(optionId) {
    return DATA.padding.find((option) => option.id === optionId && !option.disabled) || null;
  }

  function getPaddingRule(padding) {
    return DATA.paddingRules[padding] || null;
  }

  function getRecommendedThicknessId(padding) {
    return getPaddingRule(padding)?.recommendedThickness || null;
  }

  function isThicknessSupported(padding, thicknessId) {
    const rule = getPaddingRule(padding);
    return Boolean(rule && getThicknessOption('standard', thicknessId)
      && !rule.unsupportedThicknesses.includes(thicknessId));
  }

  function getThicknessOptions(route, padding) {
    if (route === 'standard') {
      const rule = getPaddingRule(padding);
      return DATA.standardThickness.map((option) => {
        const unsupported = Boolean(rule?.unsupportedThicknesses.includes(option.id));
        const recommended = !unsupported && option.id !== 'custom' && option.id === rule?.recommendedThickness;
        const suffix = unsupported ? ' · Not with this padding' : (recommended ? ' · Recommended' : '');
        return { ...option, disabled: Boolean(option.disabled || unsupported), unsupported, recommended, displayLabel: `${option.label}${suffix}` };
      });
    }
    if (route === 'folding') return DATA.foldingThickness;
    return [];
  }

  function getThicknessOption(route, optionId) {
    const options = route === 'standard' ? DATA.standardThickness : getThicknessOptions(route);
    return options.find((option) => option.id === optionId && !option.disabled) || null;
  }

  function normalizeState(rawState, options) {
    const normalized = { ...rawState };
    if (getRoute(normalized.style) !== 'standard' || !getPaddingOption(normalized.padding)) return normalized;
    const recommended = getRecommendedThicknessId(normalized.padding);
    const selected = getThicknessOption('standard', normalized.thickness);
    if (options?.paddingChanged || !selected || !isThicknessSupported(normalized.padding, normalized.thickness)) {
      normalized.thickness = recommended;
    }
    return normalized;
  }

  function toPositiveNumber(value) {
    if (value === null || value === undefined || value === '') return null;
    const number = typeof value === 'number' ? value : Number(String(value).trim());
    const maximum = DATA.bounds.safetyMaximumByField?.customThicknessMm;
    return Number.isFinite(number) && number > DATA.bounds.exclusiveMinimum
      && (!Number.isFinite(maximum) || number <= maximum) ? number : null;
  }

  function resolveCustomThickness(rawState) {
    if (getRoute(rawState.style) !== 'standard' || rawState.thickness !== 'custom') return null;
    const lugMm = toPositiveNumber(rawState.customThickness?.lugMm);
    const tipMm = toPositiveNumber(rawState.customThickness?.tipMm);
    return lugMm && tipMm ? { lugMm, tipMm } : null;
  }

  function resolveThickness(rawState) {
    const route = getRoute(rawState.style);
    const field = route === 'folding' ? 'foldingThickness' : 'thickness';
    const option = getThicknessOption(route, rawState[field]);
    if (!option) return null;
    if (route === 'standard' && option.id === 'custom') return resolveCustomThickness(rawState);
    return { lugMm: option.lugMm, tipMm: option.tipMm };
  }

  function formatPair(pair) {
    return pair ? `${pair.lugMm}mm - ${pair.tipMm}mm` : '';
  }

  return Object.freeze({ DATA, getRoute, getPaddingOption, getPaddingRule, getRecommendedThicknessId, isThicknessSupported, getThicknessOptions, getThicknessOption, normalizeState, toPositiveNumber, resolveCustomThickness, resolveThickness, formatPair });
});
